import diaQuoteLineStrategy from "./diaQuoteLine.strategy";
import iptQuoteLineStrategy from "./iptQuoteLine.strategy";
import biaQuoteLineStrategy from "./biaQuoteLine.strategy";
import wiaQuoteLineStrategy from "./wiaQuoteLine.strategy";
import eplQuoteLineStrategy from "./eplQuoteLine.strategy";
import ipAddressQuoteLineStrategy from "./ipAddressQuoteLine.strategy";
import hardwareQuoteLineStrategy from "./hardwareQuoteLine.strategy";
import fieldServiceQuoteLineStrategy from "./fieldServiceQuoteLine.strategy";
import rackAndSpaceQuoteLineStrategy from "./rackAndSpaceQuoteLine.strategy";
import crossConnectQuoteLineStrategy from "./crossConnectQuoteLine.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";
import diaQuoteLineCustomerStrategy from "./diaQuoteLineCustomer.strategy";
import iptQuoteLineCustomerStrategy from "./iptQuoteLineCustomer.strategy";
import biaQuoteLineCustomerStrategy from "./biaQuoteLineCustomer.strategy";
import wiaQuoteLineCustomerStrategy from "./wiaQuoteLineCustomer.strategy";
import ipAddressQuoteLineCustomerStrategy from "./ipAddressQuoteLineCustomer.strategy";
import eplQuoteLineCustomerStrategy from "./eplQuoteLineCustomer.strategy";
import hardwareQuoteLineCustomerStrategy from "./hardwareQuoteLineCustomer.strategy";
import fieldServiceCustomerQuoteLineStrategy from "./fieldServiceCustomerQuoteLine.strategy";
import rackAndSpaceQuoteLineCustomerStrategy from "./rackQuoteLineCustomer.strategy";
import crossQuoteLineCustomerStrategy from "./crossQuoteLineCustomer.strategy";

const vendorQuoteLineSubTable = {
  [QUOTES_TYPE[0]]: diaQuoteLineStrategy,
  [QUOTES_TYPE[1]]: iptQuoteLineStrategy,
  [QUOTES_TYPE[2]]: biaQuoteLineStrategy,
  [QUOTES_TYPE[3]]: wiaQuoteLineStrategy,
  [QUOTES_TYPE[4]]: ipAddressQuoteLineStrategy,
  [QUOTES_TYPE[5]]: eplQuoteLineStrategy,
  [QUOTES_TYPE[6]]: eplQuoteLineStrategy,
  [QUOTES_TYPE[7]]: hardwareQuoteLineStrategy,
  [QUOTES_TYPE[8]]: fieldServiceQuoteLineStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceQuoteLineStrategy,
  [QUOTES_TYPE[10]]: crossConnectQuoteLineStrategy,
};
const customerQuoteLineSubTable = {
  [QUOTES_TYPE[0]]: diaQuoteLineCustomerStrategy,
  [QUOTES_TYPE[1]]: iptQuoteLineCustomerStrategy,
  [QUOTES_TYPE[2]]: biaQuoteLineCustomerStrategy,
  [QUOTES_TYPE[3]]: wiaQuoteLineCustomerStrategy,
  [QUOTES_TYPE[4]]: ipAddressQuoteLineCustomerStrategy,
  [QUOTES_TYPE[5]]: eplQuoteLineCustomerStrategy,
  [QUOTES_TYPE[6]]: eplQuoteLineCustomerStrategy,
  [QUOTES_TYPE[7]]: hardwareQuoteLineCustomerStrategy,
  [QUOTES_TYPE[8]]: fieldServiceCustomerQuoteLineStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceQuoteLineCustomerStrategy,
  [QUOTES_TYPE[10]]: crossQuoteLineCustomerStrategy,
};
export { vendorQuoteLineSubTable, customerQuoteLineSubTable };
